import { render, staticRenderFns } from "./OTP2FAContent.vue?vue&type=template&id=4ac1c6a1&scoped=true"
import script from "./OTP2FAContent.vue?vue&type=script&lang=js"
export * from "./OTP2FAContent.vue?vue&type=script&lang=js"
import style0 from "./OTP2FAContent.vue?vue&type=style&index=0&id=4ac1c6a1&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac1c6a1",
  null
  
)

export default component.exports